import type { DictionaryBookItemFragment } from '../../../dictionary/dictionary.graphql.generated';
import {
  AI_DICTIONARY_YEAR_RANGE_3_6,
  AI_DICTIONARY_YEAR_RANGE_K_2,
  LanguageCodes,
} from 'global/constants';

export function getKTo2Definition(
  definition: DictionaryBookItemFragment,
  language: LanguageCodes
) {
  return (
    definition.aiDefinitions?.definitions.find(
      d =>
        d.year === AI_DICTIONARY_YEAR_RANGE_K_2 &&
        (d.language === language || d.language === null)
    )?.definition || ''
  );
}

export function get3To6Definition(
  definition: DictionaryBookItemFragment,
  language: LanguageCodes
) {
  return (
    definition.aiDefinitions?.definitions.find(
      d =>
        d.year === AI_DICTIONARY_YEAR_RANGE_3_6 &&
        (d.language === language || d.language === null)
    )?.definition || ''
  );
}

export function isLanguageAvailable(
  definitions: DictionaryBookItemFragment[] | null,
  language: LanguageCodes
) {
  if (definitions) {
    for (let i = 0; i < definitions.length; i++) {
      const def = definitions[i];
      const hasSpanish = def.aiDefinitions?.wordsTranslation?.some(
        wt => wt.language === language
      );
      if (hasSpanish) {
        return true;
      }
    }
  }
  return false;
}
